var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWindDirection(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 3.09998C12.5523 3.09998 13 3.54769 13 4.09998V13.9C13 14.4523 12.5523 14.9 12 14.9C11.4477 14.9 11 14.4523 11 13.9V4.09998C11 3.54769 11.4477 3.09998 12 3.09998Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 4.09998C18.5523 4.09998 19 4.54769 19 5.09998V12.9C19 13.4523 18.5523 13.9 18 13.9C17.4477 13.9 17 13.4523 17 12.9V5.09998C17 4.54769 17.4477 4.09998 18 4.09998Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 0C2.55228 0 3 0.447715 3 1V23C3 23.5523 2.55228 24 2 24C1.44772 24 1 23.5523 1 23V1C1 0.447715 1.44772 0 2 0Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.35727 2.23392C5.58373 2.04392 5.88267 1.96385 6.17379 2.01522L23.1738 5.01522C23.6516 5.09955 24 5.51477 24 6.00001V12C24 12.4852 23.6516 12.9005 23.1738 12.9848L6.17379 15.9848C5.88267 16.0362 5.58373 15.9561 5.35727 15.7661C5.1308 15.5761 5 15.2956 5 15V3.00001C5 2.70439 5.1308 2.42392 5.35727 2.23392ZM7 4.19193V13.8081L22 11.161V6.83899L7 4.19193Z",
    fill: "currentColor"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWindDirection);
export default __webpack_public_path__ + "static/media/wind_direction.8b5ab7f5c1907ce5ff5290fc6cb74272.svg";
export { ForwardRef as ReactComponent };